"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var ContentLine_1 = require("../../contentLine/ContentLine");
var VehicleSummary = function (_a) {
    var bodyStyle = _a.bodyStyle, nameplate = _a.nameplate, interior = _a.interior, exterior = _a.exterior, transmission = _a.transmission;
    var _b = core_1.useTheme().checkoutLite, showLabelWithTranslation = _b.showLabelWithTranslation, showVehicleTransmission = _b.confirmation.showVehicleTransmission;
    var intl = react_intl_1.useIntl();
    var exteriorWithTranslation = intl.formatMessage({ id: 'trans__checkout__vehicle_details__exterior_label' }) + (": " + exterior);
    var interiorWithTranslation = intl.formatMessage({ id: 'trans__checkout__vehicle_details__interior_label' }) + (": " + interior);
    return (<>
      {bodyStyle && <ContentLine_1.default mainContent={bodyStyle} dataTest="summary:vehicle:body_style"/>}
      {nameplate && <ContentLine_1.default mainContent={nameplate} dataTest="summary:vehicle:nameplate"/>}

      <ContentLine_1.default mainContent={showLabelWithTranslation ? exteriorWithTranslation : exterior} dataTest="summary:vehicle:exterior"/>
      <ContentLine_1.default mainContent={showLabelWithTranslation ? interiorWithTranslation : interior} dataTest="summary:vehicle:interior"/>
      {showVehicleTransmission && <ContentLine_1.default mainContent={transmission} dataTest="summary:vehicle:transmission"/>}
    </>);
};
exports.default = VehicleSummary;
